import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';

import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

import { ExpedienteCorteEmmasa } from './../entities/expedienteCorteEmmasa.entity';
import { Respuesta } from './../entities/respuesta.entity';
import { Factura } from './../entities/factura.entity';
import { Contrato } from './../entities/contrato.entity';
import { FacturaSeleccion } from '../entities/facturaSeleccion.entity';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';

import { AlertBoxComponent } from '../shared/alertbox.component';

declare var $: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, AfterViewInit {
  public total: number;
  public consumo: number;
  public periodo: string;
  public periodocorto: string;
  public fechalectura: string;
  public efactura: boolean;
  public contratoSelected: Contrato;
  public contrato_num: number;
  public contratos: Contrato[];
  public facturas: Array<Factura>;
  public direccionSuministro: string;
  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public Facturaseleccionada: FacturaSeleccion = new FacturaSeleccion();
  public existenFacturas: boolean;
  public telefonoexplotacion: string;
  public fechaFactura: string;
  public cobrada: boolean;
  private dateFac: Date;
  private hoy: Date;
  public expedienteCorteEmmasa: ExpedienteCorteEmmasa = new ExpedienteCorteEmmasa();
  public numeroExpCorteEmmasa: number;
  public cargoReconexion: number;
  public cargosAsocReconexion: number;
  public totalDeudaExpedienteCorteEmmasa: number;
  public TPVpage: string;
  public explotacion: string;
  public permitirPagoOVE: boolean;
  public showENS: boolean;
  public esPagadorOInactivo: boolean;
  public esFicticio: boolean;
  public procesoBajaOficio: boolean;
  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.explotacion = this.sessionService.explotacion;
    this.TPVpage = this.sessionService.TPVPage;
    this.permitirPagoOVE = this.sessionService.permitirPagoOVE;
    if (this.sessionService.isAuthenicated === true) {
      this.contratos = this.sessionService.contratos;
      this.showENS = this.sessionService.isShowedENS;
      if (this.sessionService.contratoSelected === undefined) {
        this.contratoSelected = this.sessionService.contratoSelected = this.contratos[0];
        this.cargarInfoExpedienteCorteEmmasa(this.contratoSelected.ExpedienteCorteEmmasaActivoBO);
        this.sessionService.PosicionContratoSelected = 0;
      }
      this.cargarVariables(this.sessionService.contratoSelected);
    } else {
      this.router.navigate(['/']);
    }
  }

  ngAfterViewInit() {
    if (this.showENS) {
      this.showEnsMessage();
      this.sessionService.isShowedENS = false;
    }
  }

  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    this.cargarVariables(contratoSelect);
  }

  public cargarVariables(contrato: Contrato): void {
    this.contratoSelected = contrato;
    this.sessionService.esPagadorOInactivo = this.esPagadorOInactivo = this.userService.esPagadorOInactivo(this.sessionService.contratoSelected, this.sessionService.login);
    this.sessionService.updateEsPagador();
    this.esFicticio = this.contratoSelected.Ficticio;
    this.cargarInfoExpedienteCorteEmmasa(this.contratoSelected.ExpedienteCorteEmmasaActivoBO);
    if (contrato.Facturas.length > 0) {
      this.existenFacturas = true;
      this.typeException = -1;
      this.total = contrato.Facturas[0].TotalFacturado;
      this.consumo = !this.sessionService.isEmmasa ? contrato.Facturas[0].ConsumoReal : contrato.Facturas[0].ConsumoFactura;
      this.periodo = contrato.Facturas[0].Periodo.Descripcion;
      this.periodocorto = contrato.Facturas[0].PeriodoCodigo;
      this.fechalectura = contrato.Facturas[0].FechaLecturaFactura === null ? null : contrato.Facturas[0].FechaLecturaFactura;
      this.fechaFactura = contrato.Facturas[0].Fecha;
      this.cobrada = contrato.Facturas[0].TotalCobrado >= contrato.Facturas[0].TotalFacturado;
      this.Facturaseleccionada.version = contrato.Facturas[0].Version.toString();
      this.Facturaseleccionada.contratoVersion = contrato.Facturas[0].ContratoVersion.toString();
      this.facturas = contrato.Facturas;
      let facturasPendientes = 0;
      this.hoy = new Date();
      for (const fact of contrato.Facturas) {
        if (!this.sessionService.isEmmasa) {
          this.dateFac = new Date(fact.Fecha);
          this.dateFac.setDate(this.dateFac.getDate() + 30);
          if (fact.TotalCobrado < ((fact.TotalFacturado - 5)) && (this.dateFac > this.hoy)) {
            // if (fact.Fecha<fact.Fecha)
            facturasPendientes = facturasPendientes + 1;
          }
        } else {
          this.dateFac = new Date(fact.Fecha);
          this.dateFac.setDate(this.dateFac.getDate() + 5);
          this.hoy.getDate();
          if ((fact.TotalCobrado < fact.TotalFacturado) && (this.hoy > this.dateFac)) {
            facturasPendientes++;
          }
        }
      }

      if (this.sessionService.isEmmasa && this.contratoSelected.Estado === 'C') {
        this.messageCabecera = 'Suministro suspendido por impago';
        this.typeException = !this.contratoSelected.ExistenReclamacionAbiertaBajaOficio ? 7 : 8;
      } else {
        if (facturasPendientes > 0) {
          if (facturasPendientes === 1) { // ojo  esto es para arreglar pro
            this.messageCabecera = 'Factura pendiente de cobro';
          } else {
            this.messageCabecera = 'Varias facturas pendiente de cobro';
          }
          this.typeException = 6;
        } else {
          this.messageCabecera = '';
          this.messageComplet = '';
          this.typeException = 10;
        }
      }
    } else {
      this.existenFacturas = false;
      this.messageCabecera = 'Contrato sin facturas';
      this.messageComplet = 'El contrato seleccionado no tiene ninguna factura para mostrar';
      this.typeException = 0;
    }

    this.efactura = this.sessionService.efactura;
    this.direccionSuministro = contrato.InmuebleBO.Direccion;
    this.Facturaseleccionada.contratoCodigo = contrato.Codigo.toString();
    this.Facturaseleccionada.periodoCodigo = this.periodocorto;
    this.Facturaseleccionada.duplicado = (this.sessionService.efactura);
    this.Facturaseleccionada.firmarFactura = false;
    this.Facturaseleccionada.waterMarkImageFilePath = '';
    if (this.sessionService.datosExplotacion !== undefined) {
      this.telefonoexplotacion = this.sessionService.datosExplotacion.Contacto.substring(2,
        (this.sessionService.datosExplotacion.Contacto.length - 1));
    }
  }

  public DescargarFactura() {
    this.userService.descargaFactura(this.Facturaseleccionada)
      .then(
        response => this.DescargaFacturaOnSuccess(response),
        response => this.DescargaFacturaOnError(response)
      );
  }

  public DescargaFacturaOnSuccess(response) {
    const fichero: Blob = response;
    const filename = 'factura_' + this.periodo + '.pdf';
    saveAs(fichero, filename);
    this.closeModal();
    // this.messageCabecera = 'Factura descargada correctamente';
    // this.messageComplet = 'Factura descargada correctamente';
    // this.typeException = 2;
  }

  public DescargaFacturaOnError(response) {
    this.messageCabecera = 'Error al descargar la factura';
    this.messageComplet = 'Su factura no ha podido ser descargada';
    this.typeException = 0;
    // this.resultado = response;
    // this.messageCabecera = 'Error al descargar la factura';
    // this.messageComplet = this.resultado.Ex.Message;
    // this.typeException = this.resultado.TipoExcepcion;
  }

  public subscribirFacturaElectronica() {
    const user: UsuarioUpdate = new UsuarioUpdate();
    let usuarioOnline: UsuarioOnline = new UsuarioOnline();
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.EFactura = true;
    user.UsuarioOnline = usuarioOnline;
    this.userService.updateuser(this.sessionService.explotacion, user)
      .then(
        response => this.updateuserOnSuccess(response),
        response => this.updateuserOnError(response)
      );
  }

  public updateuserOnSuccess(response) {
    this.efactura = true;
    this.sessionService.efactura = true;
    // this.messageCabecera = 'Usuario dato de alta en la factura electronica';
    // this.messageComplet = 'El usuario se ha subscrito correctamente para recibir la factura electronica';
    // this.typeException = 2;
  }

  public updateuserOnError(response) {
    // let respuesta: Respuesta = response;
    // this.messageCabecera = 'Actualización de usuario finalizado con errores';
    // this.messageComplet = respuesta.Ex.Message;
    // this.typeException = respuesta.TipoExcepcion;
  }

  public cargarInfoExpedienteCorteEmmasa(expCorteEmmasa: ExpedienteCorteEmmasa) {
    this.contrato_num = this.contratoSelected.Codigo;
    this.procesoBajaOficio = this.contratoSelected.ExistenReclamacionAbiertaBajaOficio;
    if (expCorteEmmasa !== undefined && expCorteEmmasa !== null) {
      this.expedienteCorteEmmasa = expCorteEmmasa;
      this.totalDeudaExpedienteCorteEmmasa = expCorteEmmasa.ImportePendiente +
        expCorteEmmasa.CargosAsociadosReconexion + expCorteEmmasa.CargoReconexion;
      this.numeroExpCorteEmmasa = expCorteEmmasa.Numero;
      this.totalDeudaExpedienteCorteEmmasa = this.round(this.totalDeudaExpedienteCorteEmmasa, 2);
      this.cargoReconexion = expCorteEmmasa.CargoReconexion;
      this.cargosAsocReconexion = expCorteEmmasa.CargosAsociadosReconexion;
    } else {
      this.expedienteCorteEmmasa = new ExpedienteCorteEmmasa();
      this.totalDeudaExpedienteCorteEmmasa = 0;
      this.numeroExpCorteEmmasa = 0;
      this.cargoReconexion = 0;
      this.cargosAsocReconexion = 0;
    }
  }

  public round(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  }

  public showEnsMessage() {
    this.messageCabecera = 'Aviso!';
    // tslint:disable-next-line: max-line-length
    this.messageComplet = 'En cumplimiento de la normativa de seguridad de la entidad, le recordamos que debe aplicar la normativa de seguridad vigente, y en particular, hacer un uso adecuado de la información, proteger su confidencialidad, prevenir accesos no autorizados, custodiar de manera diligente sus credenciales e informar de manera inmediata a SACYR en caso su pérdida';
    this.typeException = 0;
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  // MODAL

  _showModalFactura = false;
  _showModalPasarela = false;

  showModal() {
    return this._showModalFactura || this._showModalPasarela;
  }

  closeModal() {
    this._showModalFactura = false;
    this._showModalPasarela = false;
  }
}
